import { initializeApp } from 'firebase/app';
import '../../../assets/css/style.min.css'
import { firebaseConfig } from '../../../components/config';
import { getAnalytics } from 'firebase/analytics';
import { collection, doc, getDoc, getDocs, getFirestore, onSnapshot, orderBy, query, where, deleteDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { capitalizeFirstLetter, form, g, log, openModal_v2, q, sortObject, t } from '../../../../../utils';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const firestore = getFirestore()

const auth = getAuth()

export async function acc(uid, callback) {
  var u = await getDoc(doc(firestore, `account/${uid}`))

  if (u.exists()) {
    callback(u.data())
  }
}

export async function acc2(uid) {
  var u = await getDoc(doc(firestore, `account/${uid}`))
  return u
}

onAuthStateChanged(auth, async (user) => {
  if (user) {
    var total = 0
    var totalActual = 0

    var d = new Date();
    d.setHours(0, 0, 0, 0);

    var d2 = new Date();

    let currentRideRef;

    let addedNotification = new Audio('https://firebasestorage.googleapis.com/v0/b/kudu-ride.appspot.com/o/1_system%2Fweb%2Fmixkit-bubble-pop-up-alert-notification-2357.wav?alt=media&token=cd3e204b-456c-4b4e-9d54-34fc8b9bfe99&_gl=1*1ims33a*_ga*MTQwNDM4Mjc1MC4xNjc5NDg4OTI3*_ga_CW55HF8NVT*MTY5NTk4OTY3Mi41MzIuMS4xNjk1OTkwMTcyLjE3LjAuMA..')
    let modifiedNotification = new Audio('https://firebasestorage.googleapis.com/v0/b/kudu-ride.appspot.com/o/1_system%2Fweb%2Fmixkit-bell-notification-933.wav?alt=media&token=945a9641-f6b8-4b4c-800a-f0ddaa52b1d1&_gl=1*xyd9kx*_ga*MTQwNDM4Mjc1MC4xNjc5NDg4OTI3*_ga_CW55HF8NVT*MTY5NTk2OTU3OC41MjkuMS4xNjk1OTY5ODE2LjYwLjAuMA..')
    let cancelledNotification = new Audio('https://firebasestorage.googleapis.com/v0/b/kudu-ride.appspot.com/o/1_system%2Fweb%2Fmixkit-clear-announce-tones-2861.wav?alt=media&token=fa3cc5f5-ea4a-43c1-811d-2af26b801e4d&_gl=1*fj12cv*_ga*MTQwNDM4Mjc1MC4xNjc5NDg4OTI3*_ga_CW55HF8NVT*MTY5ODk5OTYyMS42NDYuMS4xNjk5MDAwMDgxLjYwLjAuMA..')
    let paidNotification = new Audio('https://firebasestorage.googleapis.com/v0/b/kudu-ride.appspot.com/o/1_system%2Fweb%2Fmixkit-long-pop-2358.wav?alt=media&token=8e2af75e-1435-4a79-a740-43c682306d56&_gl=1*18ve1ol*_ga*MTQwNDM4Mjc1MC4xNjc5NDg4OTI3*_ga_CW55HF8NVT*MTY5ODk5OTYyMS42NDYuMS4xNjk5MDAwMDAwLjcuMC4w')

    var ridesCol = collection(firestore, "rides")

    var constraints = [
      where("timestamp", ">=", d),
      orderBy("timestamp", "desc")
    ]

    var mQuery = query(ridesCol, ...constraints)

    const dataTable = g("data")

    async function e2(params) {
      var foobar = []

      for (let m = 0; m < params.length; m++) {
        const element = params[m];

        var fd = await acc2(element)

        foobar.push(fd)
      }

      return foobar
    }

    async function extractAp(data) {
      if (data.ap) {
        var foobar = []

        for (let m = 0; m < data.ap.length; m++) {
          const element = data.ap[m];
          foobar.push(element.id)
        }

        var fd = await e2(foobar)

        return fd
      } else {
        return "---"
      }
    }

    function getChips(params) {
      var fooChips = ""

      for (let m = 0; m < params.length; m++) {
        const element = params[m];
        const elementData = element.data()

        console.log(element.id);

        fooChips = fooChips + "" + `<li><span class="chip chip--outline text-sm"><i class="chip__label"><a href="../users/user/?id=${element.id}">${elementData.firstName}</a></i></span></li>`
      }

      return fooChips
    }

    async function driver(id, data) {
      if (data.stage > 0) {
        g(`driver_${id}`).innerHTML = `<td class="int-table__cell"><a href="../users/user/?id=${data.driver}">${data.driverName}</a></td>`
      } else {
        extractAp(data).then((fd) => {
          g(`driver_${id}`).innerHTML = `<td class="int-table__cell"><ul class="flex flex-wrap gap-xxs">${getChips(fd)}</ul></td>`
        })
      }
    }

    async function updateDetails(rideId) {
      currentRideRef = doc(firestore, "rides", rideId)

      const ride = await getDoc(currentRideRef)

      if (ride.exists()) {
        const rideData = sortObject(ride.data())

        g("_timestamp").innerText = rideData.timestamp.toDate()
        g("_stage").innerText = rideData.stage
        g("modal-title").innerText = `${rideData.destination} - ${rideData.locality}`
        g("_estimatedFare2").innerText = `ZMW${rideData.estimatedFare}`

        const info = g("_info")

        info.innerHTML = ""

        for (const key in rideData) {
          if (Object.hasOwnProperty.call(rideData, key)) {
            const element = rideData[key];

            if (key == "@accepted") {
              info.appendChild(t(`<tr class="prop-table__row">
                  <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                  <td class="prop-table__cell">${element.toDate()}</td>
              </tr>`))
            } else if (key == "pickUp" || key == "dropOff") {
              info.appendChild(t(`<tr class="prop-table__row">
                  <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                  <td class="prop-table__cell">${element.latitude},${element.longitude}</td>
              </tr>`))
            }

            switch (key) {
              case "timestamp":
                info.appendChild(t(`<tr class="prop-table__row">
                    <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                    <td class="prop-table__cell">${element.toDate()}</td>
                </tr>`))
                break
              case "@arrived":
                info.appendChild(t(`<tr class="prop-table__row">
                    <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                    <td class="prop-table__cell">${element.toDate()}</td>
                </tr>`))
                break
              case "@canceled":
                info.appendChild(t(`<tr class="prop-table__row">
                    <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                    <td class="prop-table__cell">${element.toDate()}</td>
                </tr>`))
                break
              case "@completed":
                info.appendChild(t(`<tr class="prop-table__row">
                    <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                    <td class="prop-table__cell">${element.toDate()}</td>
                </tr>`))
                break
              case "ap":
                info.appendChild(t(`<tr class="prop-table__row">
                    <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                    <td class="prop-table__cell">${JSON.stringify(element)}</td>
                </tr>`))
                break
              default:
                info.appendChild(t(`<tr class="prop-table__row">
                    <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                    <td class="prop-table__cell">${element}</td>
                </tr>`))
                break;
            }
          }
        }
      }
    }

    function formatDate(date) {
      const formatDate = new Date(
        date.seconds * 1000 + date.nanoseconds / 1000000
      );

      return formatDate
      // formatDate.toLocaleTimeString('en-us', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }

    var fiveMin = 1000 * 60 * 5;

    function stager(stage, timestamp) {
      if (stage < 10) {
        if (stage >= 3) {
          if (stage == 3) {
            return "bg-success bg-opacity-20%"
          } else {
            return "bg-success bg-opacity-20%"
          }
        } else {
          if ((d2.getTime() - formatDate(timestamp).getTime()) < fiveMin) {
            return ""
          } else {
            return "bg-warning bg-opacity-20%"
          }
        }
      } else {
        return "bg-error bg-opacity-20%"
      }
    }

    function mRide(ride, rideData) {
      return t(`<tr class="int-table__row ${stager(rideData.stage, rideData.timestamp)}">
          <th class="int-table__cell" scope="row">
              <div class="custom-checkbox int-table__checkbox">
                  <input class="custom-checkbox__input js-int-table__select-row"
                      type="checkbox" aria-label="Select this row" />
                  <div class="custom-checkbox__control" aria-hidden="true"></div>
              </div>
          </th>
          <td class="int-table__cell"><a class="ride__link" data-ride-id="${ride.id}" href="#${ride.id}">${ride.id}</a></td>
          <td class="int-table__cell" id="driver_${ride.id}">---</td>
          <td class="int-table__cell">${rideData.stage}</td>
          <td class="int-table__cell text-truncate max-width-xxxxs">ZMW${rideData.estimatedFare}</td>
          <td class="int-table__cell">${rideData.timestamp.toDate()}</td>
          <td class="int-table__cell">${rideData.locality}</td>
          <td class="int-table__cell">
              <button class="reset int-table__menu-btn margin-left-auto js-tab-focus"
                  data-label="Edit row" aria-controls="menu-example">
                  <svg class="icon" viewBox="0 0 16 16">
                      <circle cx="8" cy="7.5" r="1.5" />
                      <circle cx="1.5" cy="7.5" r="1.5" />
                      <circle cx="14.5" cy="7.5" r="1.5" />
                  </svg>
              </button>
          </td>
      </tr>`)
    }

    async function list(rides, callback) {
      dataTable.innerHTML = ""

      total = 0
      totalActual = 0

      var mRides = rides.docs

      for (let k = 0; k < mRides.length; k++) {
        const ride = mRides[k];
        const rideData = ride.data()

        dataTable.appendChild(mRide(ride, rideData))
        driver(ride.id, rideData)

        const rideStage = rideData.stage

        total += rideData.estimatedFare

        if (rideStage < 10) {
          if (rideStage >= 3) {
            if (rideStage == 3) {
              totalActual += rideData.estimatedFare
            } else {
              totalActual += rideData.total
            }
          }
        }
      }

      callback()
    }

    const unsubscribe = onSnapshot(mQuery, async (rides) => {
      list(rides, () => {
        g("all").innerText = `ZMW${Math.round((total + Number.EPSILON) * 100) / 100}`
        g("all_completed").innerText = `ZMW${Math.round((15 / 100 * total + Number.EPSILON) * 100) / 100}`

        g("aall").innerText = `ZMW${Math.round((totalActual + Number.EPSILON) * 100) / 100}`
        g("aall_completed").innerText = `ZMW${Math.round((15 / 100 * totalActual + Number.EPSILON) * 100) / 100}`


        q(".ride__link").forEach(link => {
          link.addEventListener("click", (e) => {
            e.preventDefault()

            const rideId = link.getAttribute("data-ride-id")

            updateDetails(rideId)

            openModal_v2("modal-ride", () => { })
          })
        })
      })

      rides.docChanges().forEach((change) => {
        if (change.type === "added") {
          modifiedNotification.play()
        }

        if (change.type === "modified") {
          var d = change.doc.data()

          if (d["stage"] == 11 || d["stage"] == 10) {
            cancelledNotification.play()
          } else {
            addedNotification.play()
          }
        }

        if (change.type === "removed") {

        }
      });
    })

    function compareDate(str1) {
      // str1 format should be dd/mm/yyyy. Separator can be anything e.g. / or -. It wont effect
      var dt1 = parseInt(str1.substring(0, 2));
      var mon1 = parseInt(str1.substring(3, 5));
      var yr1 = parseInt(str1.substring(6, 10));
      var date1 = new Date(yr1, mon1 - 1, dt1);
      return date1;
    }

    form("rides_filter", async (mData) => {
      unsubscribe()

      dataTable.innerHTML = ""

      total = 0
      totalActual = 0

      const mDate = compareDate(mData.ridesFilterDate)

      const clonedDate = new Date(mDate.getTime())
      clonedDate.setHours(clonedDate.getHours() + 24)

      var mConstraints = [
        where("timestamp", ">=", compareDate(mData.ridesFilterDate)),
        where("timestamp", "<", clonedDate),
        orderBy("timestamp", "desc")
      ]

      const mQuery = query(ridesCol, ...mConstraints);
      const rides = await getDocs(mQuery);

      list(rides, () => {
        g("all").innerText = `ZMW${Math.round((total + Number.EPSILON) * 100) / 100}`
        g("all_completed").innerText = `ZMW${Math.round((15 / 100 * total + Number.EPSILON) * 100) / 100}`

        g("aall").innerText = `ZMW${Math.round((totalActual + Number.EPSILON) * 100) / 100}`
        g("aall_completed").innerText = `ZMW${Math.round((15 / 100 * totalActual + Number.EPSILON) * 100) / 100}`

        q(".ride__link").forEach(link => {
          link.addEventListener("click", (e) => {
            e.preventDefault()

            const rideId = link.getAttribute("data-ride-id")

            updateDetails(rideId)

            openModal_v2("modal-ride", () => { })
          })
        })
      })
    })

    g("btn_delete_ride").addEventListener("click", () => {
      let del = confirm("Are you sure to delete ride record?");

      if (del) {
        deleteDoc(currentRideRef)
          .then(() => {
            alert("Deleted successfully!")
            location.reload()
          }).catch((e) => {
            alert(e.message)
            location.reload()
          })
      }
    })
  } else {
    alert("login please!")
  }
})

require('../../../assets/js/scripts')